var ICON_MAP = new Map([
    ['info', 'info_outline'],
    ['warn', 'warning'],
    ['error', 'error'],
]);
var UiCardInfoComponent = /** @class */ (function () {
    function UiCardInfoComponent() {
        this.hostClass = 'ui-card-info';
        this.message = '';
        this._type = 'info';
        this._typeColor = this._computeColor(this._type);
    }
    Object.defineProperty(UiCardInfoComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (type) {
            if (!type || this._type === type) {
                return;
            }
            this._type = type;
            this._typeColor = this._computeColor(this.type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCardInfoComponent.prototype, "color", {
        get: function () { return this._color || this._typeColor; },
        set: function (value) {
            this._color = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiCardInfoComponent.prototype, "icon", {
        get: function () {
            return this._icon || ICON_MAP.get(this.type);
        },
        set: function (ico) {
            this._icon = ico;
        },
        enumerable: true,
        configurable: true
    });
    UiCardInfoComponent.prototype._computeColor = function (type) {
        switch (type) {
            case 'error':
            case 'warn':
                return 'warn';
            case 'info':
            default:
                return 'accent';
        }
    };
    return UiCardInfoComponent;
}());
export { UiCardInfoComponent };
